<template lang="pug">
  .card
    .card-header
      .columns
        .column #[.h5 Últimas assinaturas]
        .column.col-auto #[i.fa-lg.fas.fa-dollar-sign]
    .card-body
      .flex-centered(v-if="subscriptions.length === 0") #[empty-list.bg-light]
      table.table.table-scroll(v-else)
        thead
          tr
            th Plano
            th.text-center Valor
            th Assinante
            th Assinou em
        tbody
          tr(v-for="subscription in subscriptions")
            td.text-ellipsis {{ subscription.plan.title }}
            td.text-center {{ subscription.plan.price | currency('R$ ') }}
            td.text-ellipsis {{ subscription.person.fullName }}
            td.text-ellipsis {{ subscription.createdAt | toDate('DD/MM/YYYY HH:mm') }}
    .card-footer(v-if="subscriptions.length > 0")
      .text-right
        router-link.btn.btn-link(:to="{ name: 'subscriptions.list' }")
          i.fas.fa-eye
          |  Ver todas
</template>

<script>
export default {
  props: { subscriptions: { type: Array, required: true } },
}
</script>

<style lang="stylus" scoped>
.card
  border-radius 0.35rem
  height 100%
</style>
